import { Components, Theme } from "@mui/material";
import { outlinedSecondarySurfaceStyles } from "./secondary-surface";

export const vrChipOverride: Components<Theme>["MuiChip"] = {
  variants: [
    {
      props: { variant: "outlined", color: "secondary", size: "medium" },
      style: ({ theme }) => ({
        ...theme.typography.textBase500,
        height: "auto",
        borderRadius: 100,
        padding: theme.spacing(1.5, 2.5),
        "& .MuiChip-label": { padding: 0 },
      }),
    },
  ],
  styleOverrides: {
    outlinedSecondary: ({ theme }) => ({
      ...outlinedSecondarySurfaceStyles(theme),
      "&.MuiChip-clickable:hover, &.MuiChip-clickable:focus": {
        backgroundColor: theme.palette.dsSurface.v200,
      },
    }),
  },
};
